export default {
  savedAll: (state) => state.savedAll,
  savedByKeywords: (state) => state.savedByKeywords,
  saved: (state) => state.saved,
  cleanSavedPost: (state) => state.cleanSavedPost,
  active: (state) => state.active,
  isLoading: (state) => state.isLoading
};
